class ModalBox {
  constructor(id) {
    this.box = document.getElementById(id)
    this.buttons = document.querySelectorAll(`[data-target="${id}"]`)
    this.close = this.box.querySelector(".modal-box__close")
    this.cover = this.box.querySelector(".modal-box__cover")
    this.listen()
  }

  listen() {
    this.buttons.forEach((button) =>
      button.addEventListener("click", () => {
        this.openModal()
      })
    )

    this.close.addEventListener("click", () => {
      this.closeModal()
    })
    addEventListener("keydown", (ev) => {
      if (ev.key === "Escape") {
        this.closeModal()
      }
    })
    this.cover.addEventListener("click", () => {
      this.closeModal()
    })
  }

  closeModal() {
    this.box.classList.remove("show")
    document.body.classList.remove("noscroll")
    if (this.box.classList.contains("modal-box--video")) {
      const source = this.box.querySelector("iframe").src
      this.box.querySelector("iframe").src = source.replace("&autoPlay=1", "")
      const preview = document.querySelector(".video-preview")
      preview.play()
    }
  }
  openModal() {
    this.box.classList.add("show")
    document.body.classList.add("noscroll")
    if (this.box.classList.contains("modal-box--video")) {
      const source = this.box.querySelector("iframe").src
      this.box.querySelector("iframe").src = source + "&autoPlay=1"
      const preview = document.querySelector(".video-preview")
      preview.pause()
      preview.currentTime = 0
    }
  }
}

export default ModalBox
